import React from 'react';
import ThisProject from '../ThisProject';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent min-h-screen'>
          <h1>{thisProject.client}</h1>
        </div>
      )}
    </ThisProject>
  )
}

export default Content